import { memo } from 'react';

type NotificationCustomFieldTextValueProps = {
  value: string;
};

export const NotificationCustomFieldTextValue = memo(({ value }: NotificationCustomFieldTextValueProps) => {
  return (
    <p className="rounded-4 ads:bg-ads-gray-4 bg-gray-4 px-1 font-medium ads:text-primary text-12 text-gray-12">
      {value}
    </p>
  );
});

NotificationCustomFieldTextValue.displayName = 'NotificationCustomFieldTextValue';
